<script>
    export let onClose;
    export let title = '';
</script>
<style>
    .title {
        grid-area: title;
        text-align: center;
        font-weight:bold;
        font-size: 1.3em;
    }
    .button {
        grid-area: button;
    }
    .button button {
/*
        background-color: #61affe;
        color: white;
*/
        background: #0066CC;
        color: white;
        font-weight:bold;
        font-size: 1em;
        line-height: 1em;
        margin: 0;
    }

    .grid {
        /* kind of hacky but top/bottom margin must be set in column or map maintaing scrollY doesn't stop filter column from scrolling indefinitely */
        margin: 0em 1em;
        padding: 0;
        display: grid;
        align-items: center;
        grid-template-columns: 1fr 1em;
        grid-template-rows: auto;
        grid-template-areas:
                "title button";
    }
</style>

<div class='grid'>
    <div class='title'>{title}</div>
    <div class='button'>
        <button on:click={onClose}>X</button>
    </div>
</div>
<hr style='margin: .75em 0 .75em' />